export enum ReferenceLineAxisOptionsType {
    ONLY_X = 'ONLY_X',
    ONLY_LEFT_Y = 'ONLY_LEFT_Y',
    X_AND_LEFT_Y = 'X_AND_LEFT_Y',
    ALL_Y = 'ALL_Y',
    ALL = 'ALL'
}
